//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      rowStyleOption: {
        stripe: true,
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          return "table-body-cell-class";
        },
      },
      columns: [
        {
          field: "name",
          key: "a",
          title: "名称",
          align: "left",
          width: 200,
          fixed: "left",
        },
        {
          field: "qichuyue",
          key: "b",
          title: "期初余额",
          width: 120,
          align: "right",
        },
        {
          field: "jiefang",
          key: "c",
          title: "借方",
          width: 120,
          align: "right",
        },
        {
          field: "daifang",
          key: "d",
          title: "贷方",
          width: 120,
          align: "right",
        },
        {
          field: "yue",
          key: "e",
          title: "余额",
          width: 120,
          align: "right",
        },
      ],
      tableData: [
        {
          name: "200102-朱洪喜",
          qichuyue: "-1,000,000.00",
          yue: "-1,000,000.00",
        },
        {
          name: "200104-陈敏旺",
          qichuyue: "-1,000,000.00",
          yue: "-1,000,000.00",
        },
        {
          name: "200107-建行0799卡贷款",
          qichuyue: "-671,000.00",
          yue: "-671,000.00",
        },
        {
          name: "200108-金彩红",
          qichuyue: "-1,000,000.00",
          yue: "-1,000,000.00",
        },
        {
          name: "200109-浙江信用社贷款",
          daifang: "1,000,000.00",
          yue: "-1,000,000.00",
        },
        {
          name: "合计",
          qichuyue: "-3,671,000.00",
          daifang: "1,000,000.00",
          yue: "-4,671,000.00",
        },
      ],
    };
  },
};
